import { gql } from '@apollo/client';

export const sessionGql = gql`
  query session($sessionId: String!) {
    session(sessionId: $sessionId) {
      _id
      entryDate
      exitDate
      startDate
      endDate
      occupancyDuration
      state
      amount
      currency
      authorizeTransactionId
      contractId
      contract {
        name1
        name2
        ospContractId
      }
      product {
        _id
        name
        code
      }

      parking {
        translation
        accessPoints {
          shortCode
          _id
        }
      }

      events {
        state
        credentials {
          type
          provider
          value
          description
        }
        accessPointId
        createdAt
        reason
        amount
      }
    }
  }
`;
